import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3219496471/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/sitemap/content.tsx");
